import { CenterCoverImg, OptimizedImg } from '@commonPackage/components';
import { toContactPage } from '@portalCommon/utils';
import { RouterConfigEnum, SCENE_CARD_DATA, SWIPE_CARD_DATA, TAB_CARD_DATA } from '@portalCommon/constants';
import { ContactType } from 'common-package';
import { Consult } from '@/components';
import { ContactUs } from '../../components';
import { SectionLayout } from '../../components/SectionLayout';
import { HoverSwipeCard } from '../../components/HoverSwipeCard';
import { TabCard } from '../../components/TabCard';
import { SceneCards } from '../../components/SceneCards';

import cx from './index.module.less';

export const Museum = () => {
  return (
    <>
      <div className={cx('top-container')}>
        <div className={cx('content')}>
          <div className={cx('title')}>元宇宙博物馆</div>
          <div className={cx('title')}>搭建立馆初心与观众诉求的桥梁</div>
          <div className={cx('brief', 'first-line')}>面向全球博物馆，激发用户兴致，强化沉浸体验</div>
          <div className={cx('brief')}>打造全新的元宇宙博物馆参观之旅</div>
          <button
            className={cx('rounded-button')}
            onClick={() =>
              toContactPage({ contactType: ContactType.activity, isMain: import.meta.env.VITE_MAIN === 'true' })
            }>
            立即咨询
          </button>
        </div>
        <CenterCoverImg src="https://static.fuxi.netease.com/yaotai/portal/index/ll22nvs4_280932.png" />
      </div>
      <div className={cx('middle-container')}>
        <OptimizedImg
          className={cx('plan')}
          src="https://static.fuxi.netease.com/yaotai/portal/index/ll2azc9s_252448.png"
          width={1920}
          alt=""
        />
      </div>
      <SectionLayout
        title="解决方案亮点"
        subTitle="将博物馆搬进元宇宙，实现藏品数字化保护与参观"
        backgroundImgUrl="https://static.fuxi.netease.com/yaotai/portal/index/ll33e3qb_970467.png">
        <HoverSwipeCard dataSource={SWIPE_CARD_DATA} />
      </SectionLayout>
      <Consult routerPath={RouterConfigEnum.CorporateSpace} tip="联系我们，免费体验网易瑶台元宇宙博物馆" />
      <SectionLayout
        title="特色功能"
        subTitle="高效策展，打破时空限制，共享元宇宙博物馆魅力"
        sectionHeight={853}
        backgroundImgUrl="https://static.fuxi.netease.com/yaotai/portal/index/ll35vi7f_141611.png">
        <TabCard dataSource={TAB_CARD_DATA} />
      </SectionLayout>
      <SectionLayout
        title="应用场景"
        subTitle="数实融合，在元宇宙空间实现博物馆的更多可能"
        sectionHeight={700}
        backgroundImgUrl="https://static.fuxi.netease.com/yaotai/portal/index/ll29kozf_889467.png">
        <SceneCards dataSource={SCENE_CARD_DATA} />
      </SectionLayout>
      <ContactUs title="为您量身定制博物馆解决方案 " />
    </>
  );
};
